import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} - 久久影视高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <div className="absolute top-2 left-2 flex gap-1.5 flex-wrap">
          {movie.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-accent-500 text-background-50 whitespace-nowrap">
              热门
            </span>
          )}
          {movie.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-primary-500 text-background-950 whitespace-nowrap">
              新上
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-1.5 py-0.5 text-xs font-semibold rounded bg-background-950/70 text-primary-500 whitespace-nowrap">
            {movie.rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-foreground-50 line-clamp-2 leading-relaxed">
            {movie.description}
          </p>
        </div>
      </div>

      <h3 className="text-sm font-heading font-medium text-foreground-50 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 whitespace-nowrap">
        {movie.title}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-foreground-500">{movie.year}</span>
        <span className="text-xs text-foreground-600">·</span>
        <span className="text-xs text-foreground-500 line-clamp-1">{movie.tags.slice(0, 2).join('/')}</span>
      </div>
    </Link>
  );
}